import React from 'react'
import { 
    Panel, PanelHeader, PanelBody, MediaBox, MediaBoxTitle, MediaBoxDescription, PanelFooter,
    CellMore, LoadMore, Cell, CellBody, CellFooter
} from 'react-weui'
import { getHumanTime, isLZWKAPP } from '../../utils'
import { browserHistory } from 'react-router'
import Empty from './Empty'


class System extends React.Component {
    renderSystemItem (system) {
        return (
            <div className="type-system msg-item" key={system.message_id}>
                <Time time={system.create_timestamp} />
                <Panel>
                    <PanelHeader className='header'>
                        <img src={system.content[0].avatar} alt=""/>
                        <span>{system.content[0].sender}</span>
                    </PanelHeader>
                    <PanelBody>
                        <MediaBox type="text">
                            <MediaBoxTitle>
                                {system.content[0].first}
                            </MediaBoxTitle>
                            <MediaBoxDescription className='description-wrap'>
                                <span className='keyword1'>{system.content[0].keyword1}</span>
                                <span className='description normal-font'>{system.content[0].description}</span>
                            </MediaBoxDescription>
                        </MediaBox>
                    </PanelBody>
                    <PanelFooter href={this.getLocation(system.content[0])}>
                        <Cell access link>
                            <CellBody>查看详情</CellBody>
                            <CellFooter />
                        </Cell>
                    </PanelFooter>
                </Panel>
            </div>
        )
    }
    renderPureText (msg) {
        return (
            <div className="msg-item type-text" key={msg.message_id}>
                <Time time={msg.create_timestamp} />
                <Panel>
                    <pre dangerouslySetInnerHTML={{__html: this.getContentText(msg.content[0].text)}}>
                        
                    </pre>
                </Panel>
            </div>
        )
    }
    getContentText (text) {
        if (isLZWKAPP()) {
            return text.replace(/<a.+?<\/a>/g, '')
        } else {
            return text
        }
    }
    getLocation (params) {
        if (!isLZWKAPP()) {
            return params.url
        }
        switch (params.object_type) {
            case 'lecture':
                return `lizhiweike://lecture?lecture_id=${params.object_id}`
                break
            case 'channel':
                return `lizhiweike://channel?channel_id=${params.object_id}`
                break
            case 'liveroom':
                return `izhiweike://liveroom?liveroom_id=${params.object_id}`
                break
            default:
                return `lizhiweike://webview?url=${params.url}`
                break
        }
    }
    renderSystemMsgs (msgs) {
        return this.props.systemMsgs.map(msg => {
            switch (msg.msg_type) {
                case 'text':
                    return this.renderPureText(msg)
                case 'push_notify':
                    return this.renderSystemItem(msg)
                case 'img':
                    return this.renderImgMsg(msg)
                default:
                    return this.renderArticle(msg)
            }
        })
    }
    renderArticle (msg) {
        return (
            <div className="msg-item type-img" key={msg.message_id}>
                <Time time={msg.create_timestamp} />
                <a style={{display:"block"}} href={msg.url}>
                    <div className="service-message-wrap"> 
                        <div className="service-title">{msg.title}</div>
                        <div className="service-time">{msg.create_time}</div>
                        <div className="service-img"><img src={msg.img}/></div>
                        <div className="service-content">
                        <pre>{msg.description}</pre>
                        </div>
                    </div>
                    <div className="weui-panel__ft border-top-line">
                        <a href={msg.url} className="weui-cell weui-cell_access weui-cell_link">
                            <div className="weui-cell__bd">查看详情</div>
                            <span className="weui-cell__ft"></span>
                        </a>
                    </div>
                </a>
            </div>
        )
    }
    renderImgMsg (msg) {
        return (
            <div className="msg-item type-img" key={msg.message_id}>
                <Time time={msg.create_timestamp} />
                <div className="service-message-wrap">
                    <img src={msg.content[0].img} />
                </div>
            </div>
        )
    }
    render() {
        if (this.props.tabId != 1) return null
        if (!this.props.systemMsgs) return <LoadMore loading></LoadMore>
        if (this.props.systemMsgs.length === 0) return <Empty />
        return (
            <div className="system">
                {
                    this.renderSystemMsgs(this.props.systemMsgs)
                }
            </div>
        )
    }
}

function Time (props) {
    return (
        <div className="time">
            <span>{getHumanTime(props.time)}</span>
        </div>
    )
}


export default System


// WEBPACK FOOTER //
// ./src/components/message/System.js